import React from 'react';

type TimeTimerIconProps = {
  width?: number;
  height?: number;
  color?: string,
  handColor?: string,
  handRotation?: number,
} & React.SVGProps<SVGSVGElement>;

export const TimeTimerIcon = ({
  width,
  height,
  color,
  handColor,
  handRotation,
  ...restProps
}: TimeTimerIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 7V3.05493C17.5 3.55237 21 7.36745 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 9.57377 3.96316 7.30267 5.648 5.6241L4.23642 4.20726C2.17864 6.25738 1 9.03658 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1H11V7H13Z"
      fill={color}
    />
    <path
      transform={`rotate(${handRotation}, 12, 12)`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 10C11.8208 10 11.6472 10.0236 11.482 10.0677L7.70711 6.29289L6.29289 7.70711L10.0677 11.482C10.0236 11.6472 10 11.8208 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
      fill={handColor}
    />
  </svg>
);

TimeTimerIcon.defaultProps = {
  width: 24,
  height: 24,
  handRotation: 0,
  color: 'black',
  handColor: 'red',
};
